// Builds the flex style for a column so the list header and the action rows
// share the same sizing. Only columns with `grow` take up the remaining space,
// columns with `shrink` may get narrower than their basis down to `minWidth`.
export const getColumnStyle = (header) => ({
    flexGrow: header.grow ? 1 : 0,
    flexShrink: header.shrink ? 1 : 0,
    flexBasis: header.width || 'auto',
    minWidth: header.minWidth || 0,
})
